import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'

const data = [
  { name: '<17', total: 42 },
  { name: '7-10', total: 85 },
  { name: '11-19', total: 147 },
  { name: '20-29', total: 189 },
  { name: '30-39', total: 235 },
  { name: '40-49', total: 178 },
  { name: '50-59', total: 121 },
  { name: '60+', total: 93 }
]

function TestAgeGroupChart() {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey='total' fill='#8884d8' />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default TestAgeGroupChart
